import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { routes } from '../constants';
import { changeNavigation, changeHead } from '../redux/head/headActions';
import { MIndexHero } from '../components/molecules';

import pageConfig from '../config/page.config';
import { householdIntro, homePageIndustrie } from '../assets/images/images';

class IntroPage extends React.Component {
	componentDidMount() {
		this.props.changeHead({
			id: pageConfig.intro.id,
			title: this.props.intl.formatMessage({ id: pageConfig.intro.title }),
			description: this.props.intl.formatMessage({ id: pageConfig.intro.description }),
			showSocialMedia: false,
		});
		this.props.changeNavigation();
	}

	render() {
		return (
			<div className="layout-intro">
				<Link to={routes.INDUSTRIAL.HOME} href={routes.INDUSTRIAL.HOME}>
					<MIndexHero
						type="left"
						title="BREAD_CRUMB.INDUSTRIAL"
						img={homePageIndustrie}
						alt="index hero"
					/>
				</Link>
				<Link to={routes.HOUSEHOLD.HOME} href={routes.HOUSEHOLD.HOME}>
					<MIndexHero
						type="right"
						title="BREAD_CRUMB.HOUSEHOLD"
						img={householdIntro}
						alt="index hero"
					/>
				</Link>
			</div>
		);
	}
}

IntroPage.propTypes = {
	changeNavigation: PropTypes.func.isRequired,
	changeHead: PropTypes.func.isRequired,
};

export default withRouter(connect(null, {
	changeNavigation,
	changeHead,
})(injectIntl(IntroPage)));



// WEBPACK FOOTER //
// ./src/pages/intro.page.js